import useUser from '../../hooks/useUser';


//table
import { createTheme, styled, ThemeProvider } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";


import useSchedule from '../../hooks/useSchedule';
import WriteLog from '../Globals/WriteLog';
import useLocation from '../../hooks/useLocation';
import { LinearProgress } from '@mui/material';


function Schedule({addrSeq}) {

    const { user } = useUser();
    WriteLog("Schedule->user", user);
        
    const {schedules} = useSchedule(user?.customer_code, user?.token, addrSeq);    
    WriteLog("Schedule->scheduls", schedules?.appointments);      
    
    //location
    const { locations } = useLocation(user?.customer_code, user?.token);
        WriteLog("Schedule->locations", locations);      
    var location = locations?.locations?.filter(l=> l.AddrSeq == addrSeq);
    if(location?.length>0) location = location[0];
        WriteLog("Schedule->location", location);



  //table
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#DDD",
      color: theme.palette.common.black,   
      height:60       
    },
    [`&.${tableCellClasses.body}`]: {          
      border:'3px solid #FFF',           
      height:50,
      padding:5,
      margin:0  
    },
    [`&.${tableCellClasses.root}`]: {            
        border:'3px solid #FFF',            
      },        
      [`&.${tableCellClasses.hover}`]: {            
        backgroundColor: "#0F0",
      },        
  }));
    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.action.hover,   
                    
        },
    })); 
    //Theme    
    const theme = createTheme({
        status: {
            danger: '#e53e3e',
        },
        palette: {
            primary: {
            main: '#02046E',
            darker: '#053e85',
            },
            neutral: {
            main: '#64748B',
            contrastText: '#fff',
            },
        },
        });


  return (
    <div className="flex-grow h-screen overflow-y-auto bg-white">

        <div className='flex pl-5 pt-5 items-center space-x-3'>
            <div className='text-2xl font-bold' >Schedule:</div>
            <div className='p-1 items-center text-center text-sm w-7 h-7 rounded-full bg-slate-300 text-black '>
              <div>{schedules?.appointments?.length}</div>
            </div>
        </div>  
        <div className='flex ml-10 mt-5 items-baseline space-x-2'>
          <div className='text-xl font-bold'>Location:</div>
          <div className='text-sm'>{addrSeq>=0?location?.Name:"All"}</div>
        </div> 
        <div className='pl-10 pr-10'>
        <ThemeProvider theme={theme}>
            {!schedules &&
                <LinearProgress color='primary' />
            }
        </ThemeProvider>                
    </div>
        <div className='pl-10 pt-2 pr-10'> 
          <TableContainer component={Paper}>
              <Table>
                  <colgroup>
                      <col width="10%" />
                      <col width="10%" />
                      <col width="20%" />
                      <col width="15%" />
                      <col width="20%" />
                      <col width="10%" />
                      <col width="20%" />                    
                  </colgroup>
                  <TableHead>
                      <TableRow>
                          <StyledTableCell align="center">WO #</StyledTableCell>
                          <StyledTableCell align="left">Date</StyledTableCell>
                          <StyledTableCell align="left">Description</StyledTableCell>                        
                          <StyledTableCell align="center">Location</StyledTableCell>
                          <StyledTableCell align="left">Address</StyledTableCell>
                          <StyledTableCell align="center">Category</StyledTableCell>                            
                          <StyledTableCell align="center">Note</StyledTableCell>                        
                      </TableRow>
                  </TableHead>
                  <TableBody> 
                    {schedules?.appointments?.map((sche) => ( 
                        <StyledTableRow key={`${sche.work_order_id}`}>
                            <StyledTableCell align="center">
                                <div className="text-black font-bold rounded-full text-center bg-gray-300" style={{backgroundColor:sche.job_cat_color}}>{sche.work_order_id}</div>                                    
                            </StyledTableCell>                            
                            <StyledTableCell align="left"><div className="text-gray-500 text-sm">{sche?.start_date !== "" &&
                              new Intl.DateTimeFormat("en-GB", {
                                year: "numeric",
                                month: "short",
                                day: "2-digit",
                                hour: 'numeric', 
                                minute: 'numeric',                                     
                                hour12: true,                                                
                                }).format(new Date(sche?.start_date))  
                            }</div></StyledTableCell>                            
                            <StyledTableCell align="left"><div className="text-gray-500 text-sm">{sche.wo_description}</div></StyledTableCell>                            
                            <StyledTableCell align="center"><div className="text-gray-500 text-sm">{sche.location_name}</div></StyledTableCell>                            
                            <StyledTableCell align="left"><div className="text-gray-500 text-sm">{sche?.full_address}</div></StyledTableCell>
                            <StyledTableCell align="center"><div className="text-gray-500 text-sm">{sche.job_cat}</div></StyledTableCell>
                            <StyledTableCell align="center"><div className="text-gray-500 text-sm">{sche.wo_note}</div> </StyledTableCell>
                        </StyledTableRow>                  
                    ))}
                  </TableBody>
            </Table>
          </TableContainer>        
        </div>        
    </div>   
  )
}

export default Schedule